import type { Country } from 'react-phone-number-input';

export const countryOptions = [
  { value: 'CH', label: 'Schweiz' },
  { value: 'DE', label: 'Deutschland' },
  { value: 'FR', label: 'Frankreich' },
  { value: 'IT', label: 'Italien' },
  { value: 'AT', label: 'Österreich' },
  { value: 'LI', label: 'Liechtenstein' },
] as const;

export type ParticipantCountry = typeof countryOptions[number]['value'];

export const genderOptions = [
  { value: 'm', label: 'Herr' },
  { value: 'f', label: 'Frau' },
  { value: 'd', label: 'Andere / Keine Angabe' },
] as const;

export type ParticipantGender = typeof genderOptions[number]['value'];

export const genderProfileOptions: ReadonlyArray<{
  value: ParticipantGender | '';
  label: string;
}> = [{ value: '', label: 'Auswählen' }, ...genderOptions];

export const defaultPhoneCountry: Country = 'CH';

export const phoneCountries: Country[] = countryOptions.map(
  (option) => option.value,
);

export const BIRTHDATE_PATTERN = /^\d\d\.\d\d\.\d\d\d\d$/;

export const BIRTHDATE_PLACEHOLDER = 'tt.mm.jjjj';
